export const languageReplace = (LanguageConfig: Record<string, string>[]) => {
  return LanguageConfig.map((items) => {
    return {
      value: items.languageCode,
      label: items.language,
    };
  });
};

export const uniqueByLanguage = (voices: Record<string, string>[]) => {
  return voices.filter(
    (item, index, self) =>
      index === self.findIndex((v) => v.language === item.language)
  );
};
